import AppBody from './AppBody';

export default AppBody;
